/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import { Button, Collapse, Tabs } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { LeftOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';

import '../shipment/ShipmentTrack.css';
import '../shipment/Support.css';
import '../receptionStore/receptionView/ReceptionView.less';
import { usePackagingFlow } from '../../context/PackagingFlowContext';
import { PackagingFlow, PackagingFlowItem } from '../../queries/api/types';
import defaultImage from '../../assets/images/default.png';

const { Panel } = Collapse;
const { TabPane } = Tabs;

const QrPackageUpdate: React.FC = () => {
    const history = useHistory();
    const location = useLocation<{
        package: PackagingFlowItem;
        packagingVoucher: string;
        modelName: string;
        typeName: string;
        typeImage: string;
        categoryName: string;
    }>();
    const { packagingFlowData, setPackagingFlowData } = usePackagingFlow();
    const pkg = location.state.package;
    const modelName = location.state.modelName;
    const typeName = location.state.typeName;
    const typeImage = location.state.typeImage;
    const categoryName = location.state.categoryName;

    const [goodCount, setGoodCount] = useState(pkg.goodCount);
    const [badCount, setBadCount] = useState(pkg.badCount);

    useEffect(() => {
        setGoodCount(pkg.goodCount);
        setBadCount(pkg.badCount);
    }, [pkg]);

    const handleValidate = () => {
        // Update only the package with the exact matching package id
        const updatedFlowData: PackagingFlow[] = packagingFlowData.map((flow: PackagingFlow) => {
            const updatedPackages: PackagingFlowItem[] = flow.packages.map((p) => {
                const pId = typeof p.package === 'string' ? p.package : p.package.id;
                const pkgId = typeof pkg.package === 'string' ? pkg.package : pkg.package.id;
                return pId === pkgId ? { ...p, goodCount, badCount } : p;
            });
            return { ...flow, packages: updatedPackages };
        });
        setPackagingFlowData(updatedFlowData);
        history.push('/qrPackageTrack');
    };

    const handleIncrement = (countType: 'goodCount' | 'badCount') => {
        if (countType === 'goodCount') {
            setGoodCount((prevCount) => prevCount + 1);
        } else {
            setBadCount((prevCount) => prevCount + 1);
        }
    };

    const handleDecrement = (countType: 'goodCount' | 'badCount') => {
        if (countType === 'goodCount') {
            setGoodCount((prevCount) => Math.max(0, prevCount - 1));
        } else {
            setBadCount((prevCount) => Math.max(0, prevCount - 1));
        }
    };

    const handleInputChange = (countType: 'goodCount' | 'badCount', value: number) => {
        if (countType === 'goodCount') {
            setGoodCount(value);
        } else {
            setBadCount(value);
        }
    };

    return (
        <>
            <div className="type-accordian">
                <div className="title mb-16">
                    <LeftOutlined className="back-icon" onClick={() => history.goBack()} />
                </div>
                <div className="reception-view has-comment support-container bg-dash">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab={categoryName} key="1">
                            <Collapse defaultActiveKey={[typeName]}>
                                <Panel
                                    header={
                                        <div className="panel-header">
                                            <img
                                                src={typeImage || defaultImage}
                                                className="header-type-image"
                                                alt="package-type"
                                            />
                                            <span>{typeName}</span>
                                        </div>
                                    }
                                    key={typeName}
                                >
                                    <div className="package-item flex-direction direction">
                                        <strong className="model-view">{modelName}</strong>
                                        <div className="flex-direction flex direction">
                                            <div className="quantity-controls quantity w-full justify-between">
                                                <span className="good-count">Bon état</span>
                                                <MinusOutlined
                                                    onClick={() => handleDecrement('goodCount')}
                                                    className="minus"
                                                />
                                                <input
                                                    type="number"
                                                    value={goodCount}
                                                    min="0"
                                                    className="input-box"
                                                    onChange={(e) =>
                                                        handleInputChange('goodCount', parseInt(e.target.value))
                                                    }
                                                />
                                                <PlusOutlined
                                                    onClick={() => handleIncrement('goodCount')}
                                                    className="plus"
                                                />
                                            </div>
                                            &nbsp; &nbsp;
                                            <div className="quantity-controls quantity w-full justify-between">
                                                <span className="good-count">Cassée</span>
                                                <MinusOutlined
                                                    onClick={() => handleDecrement('badCount')}
                                                    className="minus"
                                                />
                                                <input
                                                    type="number"
                                                    value={badCount}
                                                    min="0"
                                                    className="input-box"
                                                    onChange={(e) =>
                                                        handleInputChange('badCount', parseInt(e.target.value))
                                                    }
                                                />
                                                <PlusOutlined
                                                    onClick={() => handleIncrement('badCount')}
                                                    className="plus"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Panel>
                            </Collapse>
                        </TabPane>
                    </Tabs>
                </div>
                <div className="bottom">
                    <footer>
                        <Button type="primary" onClick={handleValidate} style={{ width: '100%', marginTop: '20px' }}>
                            Valider
                        </Button>
                    </footer>
                </div>
            </div>
        </>
    );
};

export default QrPackageUpdate;
